import React, { Component } from 'react';
// import { Router, Route, Switch } from "react-router";
// import {courtspace} from '../images/courtspace.png'; 
// import { Grid, Row, Col } from 'react-flexbox-grid';
import Stripe from './Stripe'
import Home from './Home'
import TermsAndConditions from './TermsAndConditions'
import './App.css';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import { Route, BrowserRouter as Router } from "react-router-dom";
import queryString from 'query-string'
import {FirebaseConfig} from './ApiKeys'
import * as firebase from 'firebase'
import 'firebase/firestore'
// import 'firebase/<PACKAGE>'

// initialize firebase 
if(!firebase.apps.length) {firebase.initializeApp(FirebaseConfig)}
// Initialize Cloud Firestore through Firebase
// const db = firebase.firestore();
// db.settings(settings)


class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      values:null
    }
  }

  _getStripeAuthCode=()=>{
    // const user = firebase.auth().currentUser;
    //   if (user != null) {
    //     const uid = user.uid
    //     const docRefUser = db.collection("ownerUsers").doc(uid)
    //     docRefUser.get()
    //     .then(()=>{
    //       const values = queryString.parse(this.props.location.search)
    //       // const parsed = queryString.parse(location.search);
    //       console.log('value',values);
    //       this.setState({
    //         values:values
    //       })
    //     })
    //     .then(()=>{
    //       const authCode = this.state.values
    //       docRefUser.set({
    //         authCode:authCode
    //       })
    //     })
    //   }
  }



  componentDidMount() {
    const search = this.props.location  
    // if (typeof(search) != "undefined") {
      const values = queryString.parse(search)
      // const parsed = queryString.parse(location.search);
      console.log('value',values);
    // const query = new URLSearchParams(this.props.location.search);
    // const token = query.get('token')
    // console.log(token)//123

      this.setState({
        values:values
      })
    // }
    
    
  } 





  render() {
    return (
      // <div class=" container card grey darken-4">
      <Router>
         <div class="container ">
            <Route path="/stripe" component={Stripe}/> 
            <Route path="/home" component={Home}/> 
            <Route path="/termsandconditions" component={TermsAndConditions}/> 
            {/* <Route path="/" component={Stripe}/>  */}
             <div class="col s12 ">
              <div >
              <h1> </h1>
              </div>
            </div>
            
            
          </div>
      </Router>
     
      // </div>  
    )
  }
}

export default App;


// <div className="App">
      //   <header className="App-header">
      //     {/* <img src={courtspace} className="App-logo" alt="logo" /> */}
      //     <img src={require("./images/courtspace.png")} className="App-logo" alt="logo" />
      //     <p className="App-text">
      //       Thanks for activating your account with CS!
      //     </p>
      //     {/* <a
      //       className="App-link"
      //       href="https://reactjs.org"
      //       target="_blank"
      //       rel="noopener noreferrer"
      //     >
      //       go back
      //     </a> */}
      //   </header>
      // </div>